import { Box, IconButton, Link, TextField, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { BalootUserAPIs } from "../../api/APIs";
import { useRequest } from "../../api/utils/useRequest";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { toToman } from "../../utils/Utils";
import LinksList from "../../components/wallet/LinksList";
import LastProfitBanner from "../../components/wallet/LastProfitBanner";
import CustomTextSkeleton from "../../components/shared/CustomTextSkeleton";
import CustomRectangularSkeleton from "../../components/shared/CustomRectangularSkeleton";

function WalletPage() {
  const navigate = useNavigate();
  const {
    apiCall: getWallet,
    result,
    loading,
  } = useRequest(BalootUserAPIs.wallet);

  useEffect(() => {
    getWallet();
  }, []);

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForwardIcon sx={{ color: "common.white" }} />
          </IconButton>
        }
      />
      <Box
        sx={{
          overflow: "auto",
          flex: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box>
          <Box
            sx={{
              width: "100%",
              px: "24px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              mb: "100px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body1" color="common.white">
                موجودی کیف ‌پول
              </Typography>
            </Box>
            <Box
              sx={{
                mt: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {loading ? (
                <>
                  <CustomTextSkeleton width={100} />
                  <CustomTextSkeleton width={50} />
                </>
              ) : (
                <>
                  <Typography variant="h1" color="common.white">
                    {toToman(result?.wallet?.amount || 0)}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="common.white"
                    sx={{ opacity: 0.7 }}
                  >
                    تومان
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        </Box>
        <PageContentContainer sx={{ display: "block" }}>
          <Box
            sx={{
              mt: "-100px",
              width: "100%",
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <LinksList walletId={result?.wallet?.id} loading={loading} />
            {loading ? (
              <CustomRectangularSkeleton sx={{ mt: "32px" }} height={140} />
            ) : (
              result?.profitDTO && (
                <Box mt="32px" width={"100%"}>
                  <LastProfitBanner profit={result.profitDTO} />
                </Box>
              )
            )}
          </Box>
        </PageContentContainer>
      </Box>
    </>
  );
}

export default WalletPage;
